import { Button, MagellanPopup } from 'components/atoms';
import { useRef } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { PiWarning, PiXCircle } from 'react-icons/pi';
import Popup from 'reactjs-popup';
import { PopupActions } from 'reactjs-popup/dist/types';
import { BUTTON_VARIANT } from 'types/components/button/button.interface';

interface IPopupCancelWarningProps {
  trigger?: JSX.Element;
  disabledTrigger?: boolean;
  name?: string;
  onCancel?: (actions: PopupActions) => void;
  cancelLoading?: boolean;
  transI18nKey?: string;
  isClear?: boolean;
}

const PopupCancelWarning = ({
  trigger,
  disabledTrigger,
  name = '',
  onCancel,
  cancelLoading,
  transI18nKey,
  isClear = true,
}: IPopupCancelWarningProps) => {
  const { t } = useTranslation();
  const popupRef = useRef<PopupActions>(null);
  return (
    <Popup
      ref={popupRef}
      modal
      nested
      trigger={
        trigger ?? (
          <Button
            isClear={isClear}
            onlyIcon
            variant={BUTTON_VARIANT.warning}
            disabled={disabledTrigger}>
            <Button.Icon icon={<PiXCircle />} />
          </Button>
        )
      }>
      <MagellanPopup>
        <MagellanPopup.Header className='justify-center'>
          <PiWarning />
          {t(`popup.header`)}
        </MagellanPopup.Header>
        <div className='flex flex-col opacity-55 max-w-96 text-center gap-4'>
          <p>
            <Trans
              i18nKey={transI18nKey ?? 'popup.warning-popup'}
              values={{ name: name }}
              components={{ strong: <strong /> }}
            />
          </p>
          <p>{t(`popup.question`)}</p>
        </div>
        <div className='flex gap-2 mt-4'>
          <Button isClear onClick={() => popupRef.current?.close()}>
            <Button.Text text={t(`popup.cancel`)} />
          </Button>
          <Button
            variant={BUTTON_VARIANT.warning}
            onClick={() =>
              onCancel && popupRef.current && onCancel(popupRef.current)
            }
            isLoading={cancelLoading}>
            <Button.Text text={t(`popup.approve`)} />
          </Button>
        </div>
      </MagellanPopup>
    </Popup>
  );
};

export default PopupCancelWarning;
